import React, { FC, useEffect, useState } from "react"
import { Link } from "components/core/link"
import { Button } from "components/core/button"
import classNames from "classnames"
import { Card } from "components/core/card"

const cookieBannerDismissedKey = "cookieBannerDismissed"

export const CookieBanner: FC = () => {
  const [showCookieBanner, setShowCookieBanner] = useState(false)

  const dismissCookieBanner = () => {
    localStorage.setItem(cookieBannerDismissedKey, "true")
    setShowCookieBanner(false)
  }

  useEffect(() => {
    if (localStorage.getItem(cookieBannerDismissedKey) !== "true") {
      setShowCookieBanner(true)
    }
  }, [])

  return (
    <div
      className={classNames(
        "fixed z-50 bottom-0 md:bottom-4 md:left-auto md:right-4 w-full md:max-w-sm transform transition-all",
        {
          "opacity-0 invisible translate-y-full": !showCookieBanner,
          "opacity-100 visible translate-y-0": showCookieBanner,
        }
      )}
    >
      <Card className="relative max-w-4xl mx-auto p-3 md:p-6 md:rounded-3xl">
        <div className="flex items-center mb-2">
          <div className="w-8 h-8 p-1 rounded-full bg-indigo-100/40 dark:bg-indigo-900/70 border border-transparent dark:border-indigo-600/30">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 122.88 122.25"
              className="text-gray-500 dark:text-gray-300"
            >
              <path
                d="M101.77 49.38c2.09 3.1 4.37 5.11 6.86 5.78 2.45.66 5.32.06 8.7-2.01 1.36-.84 3.14-.41 3.97.95.28.46.42.96.43 1.47.13 1.4.21 2.82.24 4.26.03 1.46.02 2.91-.05 4.35 0 .13-.01.26-.03.38-.91 16.72-8.47 31.51-20 41.93-11.55 10.44-27.06 16.49-43.82 15.69v.01c-.13 0-.26-.01-.38-.03-16.72-.91-31.51-8.47-41.93-20C5.31 90.61-.73 75.1.07 58.34c0-.13.01-.26.03-.38.9-16.74 8.71-31.61 20.47-42.09C32.34 5.37 48.09-.73 64.85.07a2.885 2.885 0 012.66 4.01c-1.17 3.81-1.25 7.34-.27 10.14.89 2.54 2.7 4.51 5.41 5.52 1.44.54 2.2 2.1 1.74 3.55h.01c-1.83 5.89-1.87 11.08-.52 15.26.82 2.53 2.14 4.69 3.88 6.4 1.74 1.72 3.9 3 6.39 3.78 4.04 1.26 8.94 1.18 14.31-.55 1.27-.4 2.62.12 3.31 1.2zm-42.49 8.48c2.77 0 5.01 2.24 5.01 5.01 0 2.77-2.24 5.01-5.01 5.01-2.77 0-5.01-2.24-5.01-5.01 0-2.77 2.25-5.01 5.01-5.01zM37.56 78.49c3.37 0 6.11 2.73 6.11 6.11s-2.73 6.11-6.11 6.11-6.11-2.73-6.11-6.11 2.73-6.11 6.11-6.11zm13.16-46.74c2.65 0 4.79 2.14 4.79 4.79s-2.14 4.79-4.79 4.79-4.79-2.14-4.79-4.79a4.79 4.79 0 014.79-4.79zm68.58.65c1.98 0 3.58 1.6 3.58 3.58s-1.6 3.58-3.58 3.58-3.58-1.6-3.58-3.58c-.01-1.97 1.6-3.58 3.58-3.58zm-25.68-9.49c2.98 0 5.39 2.41 5.39 5.39 0 2.98-2.41 5.39-5.39 5.39-2.98 0-5.39-2.41-5.39-5.39 0-2.97 2.41-5.39 5.39-5.39zM97.79.59c3.19 0 5.78 2.59 5.78 5.78 0 3.19-2.59 5.78-5.78 5.78-3.19 0-5.78-2.59-5.78-5.78.01-3.2 2.59-5.78 5.78-5.78zM76.73 80.63a8.03 8.03 0 110 16.06c-4.44 0-8.03-3.59-8.03-8.03 0-4.44 3.59-8.03 8.03-8.03zM31.91 46.78c4.8 0 8.69 3.89 8.69 8.69 0 4.8-3.89 8.69-8.69 8.69a8.69 8.69 0 110-17.38zm75.22 13.96c-3.39-.91-6.35-3.14-8.95-6.48-5.78 1.52-11.16 1.41-15.76-.02-3.37-1.05-6.32-2.81-8.71-5.18-2.39-2.37-4.21-5.32-5.32-8.75-1.51-4.66-1.69-10.2-.18-16.32-3.1-1.8-5.25-4.53-6.42-7.88-1.06-3.05-1.28-6.59-.61-10.35-13.91.19-26.88 5.6-36.77 14.42C13.74 29.69 6.66 43.15 5.84 58.29v.05l-.01.13c-.76 15.25 4.72 29.35 14.19 39.83 9.44 10.44 22.84 17.29 38 18.1h.05l.13.01c15.24.77 29.35-4.71 39.83-14.19 10.44-9.44 17.29-22.84 18.1-38v-.05l.01-.13c.07-1.34.09-2.64.06-3.91-3.22 1.21-6.24 1.38-9.07.61zm9.02 3.3zm-57.94 52.38z"
                fill="currentColor"
              />
            </svg>
          </div>
          <h2 className="text-lg font-medium ml-2">Cookie Disclaimer</h2>
        </div>

        <p className="text-sm text-gray-500 dark:text-gray-300">
          We use cookies (and other similar technologies) to collect data to improve your experience on Frontend
          Toolkit. By using Frontend Toolkit, you’re agreeing to the collection of data as described in our{" "}
          <Link to="/privacy-policy" className="font-medium !text-inherit">
            Privacy Policy
          </Link>
          .
        </p>
        <div className="mt-3 text-right">
          <Button variant="secondary" className="w-full justify-center" onClick={dismissCookieBanner}>
            Ok
          </Button>
        </div>
      </Card>
    </div>
  )
}
